module.exports = __webpack_public_path__ + "img/restore.6781b7ec.svg";